<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <a
                class="consulter"
                href="https://www.cristalis.com/upload/documents/Explication_CGA.pdf"
                target="_blank"
              >
                Qu'est ce que le CGA ?
              </a>
              <div class="row">
                <div class="col-md-12 mt">
                  <pr-input-radio
                    formControlName="includeCGA"
                    columns="3"
                    [toggle]="true"
                    [isDefault]="false"
                    label=""
                  >
                  </pr-input-radio>
                </div>
              </div>
              <div class="col-md-12 mt">
                <pr-input-date
                  formControlName="startDateCga"
                  label="Sélectionnez la date de début"
                  [derrors]="derrors"
                  [isDefault]="false"
                  [hidden]="
                    product?.get('parameters')?.get('includeCGA')?.value ==
                    false
                  "
                >
                </pr-input-date>
              </div>
              <div class="col-md-12 mt">
                <pr-input-date
                  formControlName="endDateCga"
                  label="Sélectionnez la date de fin"
                  [derrors]="derrors"
                  [isDefault]="false"
                  [hidden]="
                    product?.get('parameters')?.get('includeCGA')?.value ==
                    false
                  "
                >
                </pr-input-date>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
